<template>
<div>
    <!-- modal -->
    <b-modal id="employeePermissionCopyFormModal" centered size="lg" no-close-on-backdrop ref="employeePermissionCopyFormModal" :title=" $t('employeePermissionCopy.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col>
                    <b-form>
                        <validation-provider :name=" $t('employeePermissionCopy.employee')" :rules="{ excluded:0}" v-slot="{ errors }">
                            <label for="employee-contact-type-input">{{ $t('employeePermissionCopy.employee') }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false:null" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            id: 0,
            employeeSelect: 0,
            employeeOption: [],
            employeeIdToCopyPermissions: 0
        }
    },
    methods: {
        showInfo(employeeId) {  
            this.$refs['employeePermissionCopyFormModal'].show()
            this.employeeIdToCopyPermissions = employeeId
            const data = {
                id: this.employeeIdToCopyPermissions
            }
            const controller = {
                name: 'EmployeePermission',
                actionName: 'GetEmployeePermissionCopyInfo'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {

                    this.employeeSelect = 0
                    this.employeeOption = response.data.employeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())

                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$PrivateConfirm(this.$t("others.employee_copy_permissions"), this.$t("others.copy_permissions_message"), "warning", this.$t("others.ok_title"), this.$t("others.cancel_title"))
                        .then(result => {
                            if (result.value) {
                                const data = {
                                    employeeIdToCopyPermissions: this.employeeIdToCopyPermissions,
                                    employeeIdWherePermissionsCopiedBy: this.employeeSelect
                                }
                                const controller = {
                                    name: 'EmployeePermission',
                                    actionName: 'CopyEmployeePermission'
                                }
                                const payload = {
                                    data: data,
                                    controller: controller
                                }

                                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                                    if (response.data.resultStatus == true) {
                                        this.$bvModal.hide('employeePermissionCopyFormModal')
                                        this.$SaveAlert()
                                    } else {
                                        this.$WarningAlert(response.data.resultMessage)
                                    }
                                })
                            }
                        })
                }
            })
        },
        clear() {
            this.employeeSelect = 0
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
